
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mobileapp",
      function () {
        return require("private-next-pages/mobileapp.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mobileapp"])
      });
    }
  